import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsectaServiceBase } from './insecta.base.service';
import { IFeedbackAnswerRequest, ISurveyQuestion } from './insecta.models';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService extends InsectaServiceBase {
  public getQuestions(): Observable<ISurveyQuestion[]> {
    return this.get<ISurveyQuestion[]>(`/feedback/questions`, 'v1');
  }

  public postFeedback(request: IFeedbackAnswerRequest): Observable<void> {
    return this.post(`/feedback/answers`, 'v1', request);
  }
}
